<template>
  <div id="help">
    <el-form ref="form" :model="form" :rules="rules" label-width="80px">
      <h5 style="text-align: left;">
        親愛的使用者您好，若您對於線上招生系統的服務，有任何問題或指教，請多加利用本留言系統，
        我們將於收到訊息後，儘快處理您的疑問。 謝謝！
      </h5>
      <el-form-item label="詢問主題" prop="title">
        <el-input v-model="form.title" :maxlength="30"></el-input>
      </el-form-item> 
      <el-form-item label="回覆信箱" prop="mail">
        <el-input v-model="form.mail" :maxlength="50"></el-input>
      </el-form-item> 
      <el-form-item label="詢問內容" prop="contText">
        <el-input type="textarea" v-model="form.contText" :rows=5 :maxlength="200"></el-input>
      </el-form-item> 
      <el-form-item label="驗證碼" prop="text3">
        <el-input class="input-205"  v-model="form.text3" placeholder="輸入驗證碼" maxlength="6" tabindex="5" style="width:9.375em;">
                      <i class="el-icon-edit el-input__icon"
                        slot="suffix"/></el-input>                   
                    <img v-if="captchaInfo != null" :src="captchaInfo" style="margin: 0 0 0 0; height: 2.25em;" alt=""><a href="#" style="padding: 5px 0.6em;" title="重新產生驗證碼" tabindex="6"  @click.prevent="getCaptcha()">
                    <i class="el-icon-refresh"></i>
                    </a> 
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="submitForm('form')">{{$t('message.Send_cmd')}}</el-button>
      </el-form-item>
    </el-form>
  </div> 
</template>

<script>
import axios from "axios";
export default {
  name: 'help',
  data () {
    var checkContText = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('詢問內容不能空白'));
      }else if (value.length>200) {
        return callback(new Error('詢問內容字數太長'));
      } else {
        callback();
      }
    };
    var checkMail = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('信箱不能空白'));
      }else if (value.length>50) {
        return callback(new Error('信箱字數太長'));
      } else {
        const reg = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/;
        const email = reg.test(value);
        if (!email) {
          callback(new Error("信箱格式錯誤"));
        } else {
          callback();
        }
        //callback();
      }
    };
    var checkTitle = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('主題不能空白'));
      }else if (value.length>30) {
        return callback(new Error('主題字數太長'));  
      } else {
        callback();
      }
    };
    return {
      form: {
        title: '',
        mail: '',
        contText: '姓名：'+ "\n" +'聯絡電話：'+ "\n" ,
        sysId: this.$store.getters.getSysId,
        id: this.$store.state.user.iD,
        status: this.$store.state.user.status,
        name: this.$store.state.user.name,
        type: this.$store.state.user.type,
        text3: '',
      },
      captchaInfo: null,
      rules:{
       title:[{validator: checkTitle,trigger:"blur"}],
       mail:[{validator: checkMail,trigger:"blur"}],
       contText:[{validator: checkContText,trigger:"blur"}],
      },
      token: ''
    }
  },
  mounted() {
    this.getToken();
  },
  methods: {
    async getToken() {
      this.token ='';
      const res = await axios.get('./WebApi/Tools/get-token');
      this.token = res.data.token;      
    },
    onSubmit() {
      var vm = this
      this.$http.put('./WebApi/Tools/SendMail',this.form)
                .then((response) =>{ 
                    const h = vm.$createElement;       
                    if (true == response.data) {
                      // this.$message({
                      //   message: '恭喜您,寄件成功',
                      //   type: 'success'
                      // });        
                      vm.$notify({
                                  title: vm.$t('message.Success_txt'),
                                  dangerouslyUseHTMLString: true,
                                  message: '<strong>恭喜您,寄件成功</strong>',
                                  type: 'success',
                                  offset: 150
                                });
                      this.getCaptcha()
                    } else {
                      //this.$message.error('對不起,寄件失敗');
                      vm.$notify.error({
                                        title: vm.$t('message.Error_txt'),
                                        dangerouslyUseHTMLString: true,
                                        message: '<strong>對不起,寄件失敗</strong>',
                                        offset: 150
                                      });
                    }
                })
                .catch(function (error) {
                  //this.$message.error('對不起,網路連線失敗');
                  vm.$notify.error({
                                    title: vm.$t('message.Error_txt'),
                                    dangerouslyUseHTMLString: true,
                                    message: '<strong>對不起,網路連線失敗' + error+'</strong>',
                                    offset: 150
                                  });
                })
    },
    getCaptcha: function () {
      var vm = this
      this.$http
        .get('./WebApi/Tools/GetCaptcha/')
        .then(function (response) {
          vm.captchaInfo = response.data
        })
        .catch(function (error) {
          //vm.$message.error('對不起,網路連線失敗' + error)
          vm.$notify.error({
                              title: vm.$t('message.Error_txt'),
                              dangerouslyUseHTMLString: true,
                              message: '<strong>對不起,網路連線失敗' + error+'</strong>',
                              offset: 150
                          });
        })
    },
    submitForm(form) {
      this.$refs.form.validate((valid) => {        
        console.log('======submitForm ===== valid:'+valid)
        if (valid) {
          var vm = this
          this.$http.put('./WebApi/Tools/SendMail',this.form, {
          headers: { 'X-Form-Token': this.token }
          }).then((response) =>{ 
                        const h = vm.$createElement;       
                        if (true == response.data) {
                          // this.$message({
                          //   message: '恭喜您,寄件成功',
                          //   type: 'success'
                          // });
                          vm.$notify({
                                      title: vm.$t('message.Success_txt'),
                                      dangerouslyUseHTMLString: true,
                                      message: '<strong>恭喜您,寄件成功</strong>',
                                      type: 'success',
                                      offset: 150
                                    });
                          vm.getToken(); // 提交後更新 Token
                          vm.form.title= "";
                          vm.form.mail= "";
                          vm.form.contText= '姓名：'+ "\n" +'聯絡電話：'+ "\n";      
                          vm.form.text3= "";
                          vm.getCaptcha();
                        } else {
                          //this.$message.error('對不起,寄件失敗');
                          vm.$notify.error({
                                            title: vm.$t('message.Error_txt'),
                                            dangerouslyUseHTMLString: true,
                                            message: '<strong>對不起,寄件失敗</strong>',
                                            offset: 150
                                          });
                          vm.getToken(); // 提交後更新 Token
                          vm.form.text3= "";
                          vm.getCaptcha();
                        }
                    })
                    .catch(function (error) {
                      vm.$message.error('對不起,網路連線失敗');
                      // vm.$notify.error({
                      //                   title: vm.$t('message.Error_txt'),
                      //                   dangerouslyUseHTMLString: true,
                      //                   message: '<strong>對不起,網路連線失敗' + error+'</strong>',
                      //                   offset: 150
                      //                 });                      
                    })
        } else {
          //this.$message.error('對不起,驗證失敗');
          this.$notify.error({
                              title: this.$t('message.Error_txt'),
                              dangerouslyUseHTMLString: true,
                              message: '<strong>對不起,驗證失敗</strong>',
                              offset: 150
                            });
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$nextTick(function() {
        this.$refs[formName].resetFields();
      })
    }
  },
  created () {
    console.log('======created MainView=====')
    this.getCaptcha();
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/HelpView.vue